import { useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  ADD_SEASON,
  GET_SEASONS_BY_COMPETITION_ID,
  SEASONS_WITH_PERMISSION,
} from "../../GraphQL/Season";
import useNotification from "../../hooks/useNotification.js";

const NewSeasonDialog = (props) => {
  const [season, setSeason] = useState({ name: "", startDate: "", endDate: "" });
  const { notifySuccess } = useNotification();

  const isValid =
    season.name.trim().length > 0 && !!season.startDate && !!season.endDate;

  const [addSeason, { loading, error }] = useMutation(ADD_SEASON, {
    variables: {
      name: season.name,
      startDate: season.startDate,
      endDate: season.endDate,
      competitionId: props.competitionId,
    },
    refetchQueries: [GET_SEASONS_BY_COMPETITION_ID, SEASONS_WITH_PERMISSION],
    onCompleted: () => { notifySuccess("Season created."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isValid) {
            addSeason();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Season"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TextField
            data-testid="name"
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => {
              setSeason({ ...season, name: e.target.value });
            }}
            InputProps={{ inputProps: { maxLength: 20 } }}
            helperText={`${season.name.length}/20`}
          />
          <TextField
            data-testid="startDate"
            margin="dense"
            id="startDate"
            label="Start Date"
            type="date"
            fullWidth
            variant="standard"
            onChange={(e) => {
              setSeason({ ...season, startDate: e.target.value });
            }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            data-testid="endDate"
            margin="dense"
            id="endDate"
            label="End Date"
            type="date"
            fullWidth
            variant="standard"
            onChange={(e) => {
              setSeason({ ...season, endDate: e.target.value });
            }}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveNewSeasonDialogButton"
            variant="contained"
            onClick={() => addSeason()}
            disabled={loading || !isValid}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Create"
            )}
          </Button>
          <Button
            data-testid="closeNewSeasonDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default NewSeasonDialog;
